export default {
    currentPage: null,
    lastPage: null,
    itemsPerPage: 10,
    pageOptions: [10, 50, 100, 150],
    searchQuery: ''
};
